'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validation = require('utils/validation');

var loginValidation = (0, _validation.createValidator)({
  name: [_validation.required, (0, _validation.maxLength)(20)],
  password: [_validation.required, (0, _validation.minLength)(4), (0, _validation.maxLength)(20)]
}); /**
     * Created by Administrator on 2016/5/23.
     */

exports.default = loginValidation;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Login/loginValidation.js
 ** module id = 310
 ** module chunks = 0
 **/